var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--spin-line",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.lineStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }